import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { Link } from "gatsby";
import { getStyles } from "../util/getStyles";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

const Paragraph = (props) => {
  const [styles, setStyles] = useState({});
  useEffect(() => {
    let newStyles = {};
    newStyles = { ...getStyles(props), textDecoration: "none" };
    setStyles(newStyles);
  }, [props]);

  return ReactHtmlParser(props.editor);
};
export default Paragraph;
